module.exports = __webpack_public_path__ + "static/media/register.d2b4eea3.png";